import { reviews } from "@/mocks/articles";
import ReviewCard from "@/components/feature/ReviewCard";

export default function ReviewWall() {
  return (
    <section className="bg-background-100 py-16 md:py-20">
      <div className="px-6 md:px-14">
        <div className="text-center mb-12">
          <div className="flex items-center justify-center gap-2 mb-3">
            <span className="w-2 h-2 rounded-full bg-primary-500"></span>
            <span className="text-xs font-medium text-foreground-500 uppercase tracking-widest">瓜友口碑</span>
          </div>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            百万瓜友的
            <br className="md:hidden" />
            真实评价
          </h2>
          <p className="text-foreground-500 text-sm max-w-md mx-auto">
            听听每天都在吃瓜的小伙伴们怎么说
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {reviews.map((review, idx) => (
            <ReviewCard
              key={review.id}
              name={review.name}
              avatar={review.avatar}
              role={review.role}
              rating={review.rating}
              content={review.content}
              isLast={idx >= reviews.length - 2}
            />
          ))}
        </div>
      </div>
    </section>
  );
}